import React, { Component } from 'react'

export default class Education extends Component {
  render() {
    return (
      <div>	<section class="colorlib-education" data-section="education">
      <div class="colorlib-narrow-content">
          <div class="row">
              <div class="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                  <span class="heading-meta">Education</span>
                  <h2 class="colorlib-heading animate-box">Education</h2>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12 animate-box" data-animate-effect="fadeInLeft">
                  <div class="fancy-collapse-panel">
                      <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                          <div class="panel panel-default">
                              <div class="panel-heading" role="tab" id="headingOne">
                                  <h4 class="panel-title">
                                      <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">Master Of Science In Information Systems, Northeastern University, USA
                                      </a>
                                  </h4>
                              </div>
                              <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                                   <div class="panel-body">
                                      <div class="row">
                                            <div class="col-md-11">
                                                <p>Relevant Courses:
                                                    <ul>
                                                        <li>
                                                        Web Design and User Experience Engineering
                                                        </li>
                                                        <li>
                                                        Web Development methods and tools
                                                        </li>
                                                        <li>
                                                        Network Structures and Cloud Computing
                                                        </li>
                                                        <li>
                                                        Big Data Engineering
                                                        </li>
                                                        <li>
                                                        Data Science with Python
                                                        </li>
                                                        <li>
                                                        Application Engineering and Development
                                                        </li>
                                                    </ul>
                                                    
</p>
                                            </div>
                                           
                                           
                                                                                   </div>
                                   </div>
                              </div>
                          </div>

                          <div class="panel panel-default">
                              <div class="panel-heading" role="tab" id="headingTwo">
                                  <h4 class="panel-title">
                                      <a data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">Bachelor Of Engineering In Information Technology, University Of Mumbai, India
                                      </a>
                                  </h4>
                              </div>
                              <div id="collapseTwo" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingTwo">
                                   <div class="panel-body">
                                      <div class="row">
                                            <div class="col-md-11">
                                            <p>Relevant Courses:
                                                    <ul>
                                                        <li>
                                                        Web Programming Methodologies
                                                        </li>
                                                        <li>
                                                        Advance Web Development
                                                        </li>
                                                        <li>
                                                        Distributed Systems
                                                        </li>
                                                        <li>
                                                        Data Structures and Algorithms
                                                        </li>
                                                        <li>
                                                        Aritificial Intelligence
                                                        </li>
                                                        <li>
                                                        Cloud Computing
                                                        </li>
                                                        <li>
                                                        Computer Networks
                                                        </li>
                                                        <li>
                                                            Object Oriented Programming using JAVA
                                                        </li>
                                                        <li>
                                                            Software Engineering
                                                        </li>
                                                        <li>
                                                            Software Project Management
                                                        </li>
                                                        <li>
                                                            Software Quality Assurance and Testing
                                                        </li>
                                                        <li>
                                                            System and Web Security
                                                        </li>
                                                    </ul>
                                                    </p>
                                            
                                            </div>
                                           
                                           
                                                                                   </div>
                                   </div>
                              </div>
                          </div>
                         
                        
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section></div>


      )
    }
  }